import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { api } from "../../Appjs/api";
import { rcsbaseurl } from "../../Appjs/api";

export const trueCallerApi = createApi({
  reducerPath: "trueallerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["truecallerApi"],
  endpoints: (builder) => ({
    getTrueCallerNumber: builder.query({
      query: () => ({
        url: `${rcsbaseurl}/truecaller/get-customer-numbers`,
        method: "GET",
      }),
    }),
    createTruecaller: builder.mutation({
      query: (formdata) => ({
        url: `${rcsbaseurl}/truecaller/create-campaign`,
        method: "POST",
        body: formdata,
      }),
    }),
    testTruecaller: builder.mutation({
      query: (formdata) => ({
         url:`${rcsbaseurl}/truecaller/create-test-campaign`,
        method: "POST",
        body: formdata,
      }),
    }),
 getCampaignbody:builder.query({
            query:()=>({
                url:`${rcsbaseurl}/truecaller/get-campaignbody`,
                method:"GET"
            })
        }),

    createTCtemplate: builder.mutation({
      query: (formdata) => ({
        url: `${rcsbaseurl}/truecaller/create-tc-template`,
        method: "POST",
        body: formdata,
      }),
    }),
    posttruecallerTemplate: builder.mutation({
      query: (formdata) => ({
        url: `${rcsbaseurl}/truecaller/create-tc-template`,
        method: "POST",
        body: formdata,
      }),
    }),  
  }),
});

export const {useGetTrueCallerNumberQuery,
              useCreateTruecallerMutation,
               useTestTruecallerMutation,
             useCreateTCtemplateMutation,
                useGetCampaignbodyQuery, 
                usePosttruecallerTemplateMutation, 
            } =trueCallerApi


